import { styled as t, modifier as e, css as i } from "@lokalise/styled";
import { value as o, typography as a } from "../../utils/theme/index.js";
const n = t.p`
	font-family: ${o("font.family.default")};
	margin: 0;
	display: grid;
	${e(
  "$alignRight",
  i`
			text-align: right;
		`
)}
`, p = t.span`
	${a("body.tiny.default")};
	text-transform: uppercase;
	color: ${o("color.text.light.default")};
	white-space: nowrap;
`, f = t.span`
	font-size: 20px;
	line-height: 22px;
	font-weight: 100;
	color: ${o("color.text.light.default")};
`;
export {
  n as Container,
  p as Title,
  f as Value
};
//# sourceMappingURL=styles.js.map
